import { render, staticRenderFns } from "./showInformationCustomerViews.vue?vue&type=template&id=68319aee"
import script from "./showInformationCustomerViews.vue?vue&type=script&lang=js"
export * from "./showInformationCustomerViews.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports